import React, {useRef} from 'react'
import { getAuth, updatePassword } from "firebase/auth";
export default function ChangePassword({goHome}) {
    console.log(goHome);
    const auth = getAuth();
    const user = auth.currentUser;
    if (user==null){
        alert("An internal error occured that prevents us from changing thy password.");
        goHome();
    }
    const confirmPasswordRef = useRef();
    const passwordRef = useRef();
    function submitChangePassword(e) {
        let password=passwordRef.current.value;
        let confirmPassword=confirmPasswordRef.current.value;
        console.log("Changeing password",password,confirmPassword);
        if (password!==confirmPassword){
            alert("Password and confirmation password do not match.  Please try again.");
            passwordRef.current.value=null;
            confirmPasswordRef.current.value=null;
            return;
        }
        updatePassword(user, password).then(() => {
            alert("Your password has been changed.");
            goHome();
          }).catch((error) => {
            const errorCode = error.code;
            alert("An attempt to change password failed. This may be an internal error."+
                  "Please contact OYM technical support and provide them with this code->"+'"'+errorCode+'"');
          });
    }

  return (
    <div>
        <h1>Change Password</h1>
        <table>
            <tbody>
                <tr>
                    <td><label for="passwordId">Password:</label></td>
                    <td><input size="30" ref={passwordRef} type="password" id="passwordId"></input></td>
                </tr>
                <tr>
                    <td><label for="confirmPasswordId">Confirm Password:</label></td>
                    <td><input size="30" type="password" id="confirmPasswordId" ref={confirmPasswordRef} ></input></td>
                </tr>               
                <tr>
                    <td><button onClick={submitChangePassword}>Change Password</button></td>
                </tr>
            </tbody>    
            </table>
    </div>
  )
}
